import { jsxs, jsx } from "react/jsx-runtime";
import { ToggletipContainer } from "./components/ToggletipContainer.js";
import { ToggletipDescription } from "./components/ToggletipDescription.js";
import { ToggletipExplainer } from "./components/ToggletipExplainer.js";
import { ToggletipPopover } from "./components/ToggletipPopover.js";
const Toggletip = ({
  message,
  showLabel,
  ariaLabel,
  placement,
  variant = "default",
  isOpen,
  id,
  ...props
}) => /* @__PURE__ */ jsxs(ToggletipContainer, { placement, open: isOpen, ...props, children: [
  /* @__PURE__ */ jsx(ToggletipExplainer, { variant, ariaLabel, showLabel }),
  /* @__PURE__ */ jsx(ToggletipPopover, { id, children: /* @__PURE__ */ jsx(ToggletipDescription, { children: message }) })
] });
export {
  Toggletip
};
